import footerStyles from "./Footer.module.css";
import layoutStyles from "./Layout.module.css";

export function Footer() {
	return (
		<footer className={footerStyles.footer}>
			<div className={layoutStyles.homeContainer}>
				<div className={layoutStyles.homeContent}></div>
			</div>
		</footer>
	);
}
